import { render, staticRenderFns } from "./editUserForTarget.vue?vue&type=template&id=0d125ce1&scoped=true&"
import script from "./editUserForTarget.vue?vue&type=script&lang=js&"
export * from "./editUserForTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d125ce1",
  null
  
)

export default component.exports